import { render, staticRenderFns } from "./MyCp5.vue?vue&type=template&id=d8813464&scoped=true&"
import script from "./MyCp5.vue?vue&type=script&lang=js&"
export * from "./MyCp5.vue?vue&type=script&lang=js&"
import style0 from "./MyCp5.vue?vue&type=style&index=0&id=d8813464&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8813464",
  null
  
)

export default component.exports